import { apiUrl, get } from './apiUtils';

const baseUrl = apiUrl + '/lens/';

export function getUserLens(id: string): Promise<unknown> {
  return get(`${baseUrl}user/${id}`);
}

export function getCompanyLens(id: string): Promise<unknown> {
  return get(`${baseUrl}company/${id}`);
}
